export class Automatitzacio {
  activo: boolean;
  horaEjecucion: string;
  frecuenciaHoras: string;
  diesEnrere: number;
  numeroDies: number;
}
